<template>
    <div>
        <playerStatList :game_id="game_id"></playerStatList>
    </div>
</template>

<script>

import playerStatList from '@/components/games/player_stat/list.vue';

export default {
    components: {
        playerStatList
    },
    data () {
        let self = (window.x = this)
        return {
            game_id: 1,
        }
    },
    methods: {
    },
    mounted () {
    },
    watch: {},
    computed: {}
}
</script>